export default "__VITE_ASSET__65ab9819__"